export type PrizmScrollbarVisibility = `auto` | `hidden` | `visible`;
